


























import { Component, Vue } from "vue-property-decorator";

import { ILanguage, languageIDs, specialLanguages } from "../domain";
import { languagesQuery } from "../drivers/apollo";
import AllLanguages from "./AllLanguages.vue";
import MenuItem from "./MenuItem.vue";
import Query from "./Query.vue";
import RecentlyViewedLanguages from "./RecentlyViewedLanguages.vue";

@Component({
  components: { AllLanguages, MenuItem, Query, RecentlyViewedLanguages }
})
export default class extends Vue {
  private languageIDs = languageIDs;
  private query = languagesQuery;
  private readonly specialLanguages = specialLanguages;

  private toggleMenu(): void {
    this.$store.commit("toggleMenu");
  }

  private get menuOpen(): boolean {
    return this.$store.state.menuOpen;
  }
}
